package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable
import kz.dentalcrm.app.data.network.response_model.services.Service

@Serializable
data class Employee(
    val account: Account? = null,
    val account_id: Int? = null,
    val birth_date: String? = null,
    val color: String? = null,
    val created_at: String? = null,
    val deleted_at: String? = null,
    val gender: String? = null,
    val id: Int,
    val name: String? = null,
    val organization_id: Int? = null,
    val patronymic: String? = null,
    val phone: String? = null,
    val positions: List<Position>? = null,
    val services: List<Service>? = null,
    val surname: String? = null,
    val updated_at: String? = null
)